import Vue from "vue";
import Router from "vue-router";
import layoutHeader from "@/components/layout";
import { getPageMapParams, handleJumpPage, isPC, setBury } from "../utils";
import { goLogin } from "@/plugins/http/api";
import {
  PAGE_DETAILS,
  PAGE_PERSONAL,
  PAGE_REGISTER,
  PAGE_REVIEW,
  PAGE_REVIEW_DETAIL,
  isLogin,
  sites,
} from "@/utils/constant";
import store from "../store";
import i18n from "@/i18n";
Vue.use(Router);

const PC = [
  {
    path: `/:region${sites}`,
    redirect: "/:region/index.html",
    component: layoutHeader,
    children: [
      {
        path: "index.html",
        name: "index",
        meta: {
          title: "poprun",
        },
        component: () => import("@/pc-pages/index/index"),
      },
      {
        path: "details.html",
        name: "details",
        meta: {
          title: "details_poprun",
        },
        component: () => import("@/pc-pages/details/index"),
      },
      {
        path: "register.html",
        name: "register",
        meta: {
          title: "register_poprun",
          requiresAuth: true,
        },
        component: () => import("@/pc-pages/register/index"),
      },
      {
        path: "personal.html",
        name: "personal",
        meta: {
          title: "end_poprun",
          requiresAuth: true,
        },
        component: () => import("@/pc-pages/personal/index"),
      },
      {
        path: "registerEnd.html",
        name: "registerEnd",
        meta: {
          title: "registerEnd_poprun",
          requiresAuth: true,
        },
        component: () => import("@/pc-pages/registerEnd/index"),
      },
      {
        path: "review.html",
        name: "review",
        meta: {
          title: "review_poprun",
          requiresAuth: true,
        },
        component: () => import("@/pc-pages/review/index"),
      },
      {
        path: "reviewDetail.html",
        name: "reviewDetail",
        meta: {
          title: "reviewDetail_poprun",
          requiresAuth: true,
        },
        component: () => import("@/pc-pages/review/Detail"),
      },
      {
        path: "*",
        name: "404",
        component: () => import("@/components/404"),
      },
    ],
  },
  {
    path: `*`,
    redirect: "/global/index.html",
  },
];
const MOBILE = [
  {
    path: `/:region${sites}`,
    redirect: "/:region/index.html",
    component: layoutHeader,
    children: [
      {
        path: "index.html",
        name: "index",
        meta: {
          title: "poprun",
        },
        component: () => import("@/mobile-pages/index/index"),
      },
      {
        path: "details.html",
        name: "details",
        meta: {
          title: "details_poprun",
        },
        component: () => import("@/mobile-pages/details/index"),
      },
      {
        path: "register.html",
        name: "register",
        meta: {
          title: "register_poprun",
          requiresAuth: true,
        },
        component: () => import("@/mobile-pages/register/index"),
      },
      {
        path: "personal.html",
        name: "personal",
        meta: {
          title: "end_poprun",
          requiresAuth: true,
        },
        component: () => import("@/mobile-pages/personal/index"),
      },
      {
        path: "registerEnd.html",
        name: "registerEnd",
        meta: {
          title: "registerEnd_poprun",
          requiresAuth: true,
        },
        component: () => import("@/mobile-pages/registerEnd/index"),
      },
      {
        path: "review.html",
        name: "review",
        meta: {
          title: "review_poprun",
          requiresAuth: true,
        },
        component: () => import("@/mobile-pages/review/index"),
      },
      {
        path: "reviewDetail.html",
        name: "reviewDetail",
        meta: {
          title: "reviewDetail_poprun",
          requiresAuth: true,
        },
        component: () => import("@/mobile-pages/review/Detail"),
      },
      {
        path: "*",
        name: "404",
        component: () => import("@/components/404"),
      },
    ],
  },
  {
    path: `*`,
    redirect: "/global/index.html",
  },
];

const routes = isPC() ? PC : MOBILE;

const router = new Router({
  routes,
  mode: "history",
  base: "/poprun/", //设置路径前缀
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
});

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title || "xiaomi_poprun";
  const requiresAuth = to.meta.requiresAuth;
  if (requiresAuth && !isLogin) {
    !isLogin && goLogin();
  } else if (requiresAuth) {
    try {
      await store.dispatch("getUserInfo");
      const userInfo = store.state.userInfo;
      const { isRegister, countryCode } = userInfo;
      if (isRegister && requiresAuth) {
        i18n.locale = to.params.region;
        if (
          (to.path.includes(PAGE_DETAILS) || to.path.includes(PAGE_REGISTER)) &&
          !to.path.includes(PAGE_PERSONAL)
        ) {
          i18n.locale = countryCode;
          memoRouter(PAGE_PERSONAL);
          setBury("event_page_view", getPageMapParams(PAGE_PERSONAL), {
            user_mid: isLogin,
            platform: isPC() ? "pc" : "m",
            site: countryCode,
          });
          handleJumpPage(PAGE_PERSONAL, countryCode);
          return;
        } else {
          i18n.locale = to.params.region;
          memoRouter(to.path);
          setBury("event_page_view", getPageMapParams(to.path), {
            user_mid: isLogin,
            platform: isPC() ? "pc" : "m",
            site: to.params.region,
          });
          next();
          return;
        }
      } else {
        i18n.locale = to.params.region;
        memoRouter(to.path);
        setBury("event_page_view", getPageMapParams(to.path), {
          user_mid: isLogin,
          platform: isPC() ? "pc" : "m",
          site: to.params.region,
        });
        next();
        return;
      }
    } catch (error) {
      goLogin();
    }
  } else {
    isLogin && (await store.dispatch("getUserInfo"));
    i18n.locale = to.params.region;
    memoRouter(to.path);
    setBury("event_page_view", getPageMapParams(to.path), {
      user_mid: isLogin,
      platform: isPC() ? "pc" : "m",
      site: to.params.region,
    });
    next();
    return;
  }
  isLogin && (await store.dispatch("getUserInfo"));
  i18n.locale = to.params.region;
  memoRouter(to.path);
  setBury("event_page_view", getPageMapParams(to.path), {
    user_mid: isLogin,
    platform: isPC() ? "pc" : "m",
    site: to.params.region,
  });
  next();
});

const memoRouter = (path) => {
  let page = path.split("/")[path.split("/").length - 1];
  const PAGE_STACK = JSON.parse(sessionStorage.getItem("PAGE_STACK")) || [];
  if (PAGE_STACK.length === 3) {
    PAGE_STACK.shift();
  }
  // 刷新不记录
  if (page && PAGE_STACK[PAGE_STACK.length - 1] !== page) {
    PAGE_STACK.push(page);
    sessionStorage.setItem("PAGE_STACK", JSON.stringify(PAGE_STACK));
  }
};
export default router;
